export default __webpack_public_path__ + "static/media/skeleton.1effa309.mp4";